/**
 * SC-06 — the current slide's text shapes that a rewrite can be written back to, by id. The text
 * shapes inside groups count too (AIVA-9184): on most designed slides the content sits in groups.
 */

import { readCurrentSlideTextShapes, type SlideShapesReadResult } from "../../../services/slideShapes";
import type { RephraseReadResult } from "../types";

// Groups and tables report text but have no TextFrame of their own, so a rewrite can't be written back by id.
// A group's text shapes are listed separately, after it.
const NOT_WRITABLE: ReadonlySet<string> = new Set(["group", "table"]);

export async function readRephraseTargets(
  read: () => Promise<SlideShapesReadResult> = readCurrentSlideTextShapes,
): Promise<RephraseReadResult> {
  const result = await read();
  if (result.status === "no_slide") return { kind: "no_slide" };
  if (result.status === "unsupported") return { kind: "unsupported", errorCode: result.errorCode };
  if (result.status === "empty") return { kind: "no_text" };

  const targets = result.shapes
    .filter((s) => s.hasText && !s.textUnavailable && !NOT_WRITABLE.has(s.type.toLowerCase()))
    .map((s) => ({ id: s.id, ...(s.groupPath ? { groupPath: s.groupPath } : {}), original: s.text }));
  if (targets.length === 0) return { kind: "no_text" };
  const shapeIds = result.shapes.filter((s) => !s.groupPath).map((s) => s.id);
  return { kind: "ok", shapeIds, targets };
}
